// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3mCqD","legacyBtn":"MutateMid_legacyBtn__3j1fi"};